export class RateWithRebate {
    constructor(
        public buy: number,
        public buyChange: number,
        public sale: number,
        public saleChange: number,
        public buyWithRebate: number,
        public saleWithRebate: number,
        public flagPrefix: string,
        public symbol: string) {
    }
}